import React from 'react'
import Draggable from './Draggable';
import { v4 as uuidv4 } from 'uuid';
import { getBoundingClientRect } from '../../utils/functions'

class DraggableList extends React.Component {
    constructor() {
        super()
        this.state = {
            shadowTop: null,
            shadowLeft: null
        }
    }


    componentDidMount() {
        // window.addEventListener('drag', (e)=>{console.log(e)})

    }

    dragStarted = (e, id, index) => {

        let source = this.props.id
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData("id", id);
            e.dataTransfer.setData("index", index);
            e.dataTransfer.setData("source", source);

        } else {
            e.dataTransfer.id = id;
            e.dataTransfer.index = index;
            e.dataTransfer.source = source
        }

        this.setState({ dragId: id })
        if (this.props.setDragInfo) {
            this.props.setDragInfo(id, source)
        }

        // let width = this.draggableList.getBoundingClientRect().width
        // this.setState({width})
        // this.changeShadowPosition()
        // console.log("dragStarted")
        // document.onmousemove = (e)=>{
        //     this.changeShadowPosition(e)
        // }

        // window.addEventListener('mouseup', (e)=>{console.log("DROPP")})
        // window.addEventListener('drag', (e)=>{console.log(e)})

        // document.addEventListener('mousemove', this.changeShadowPosition)

        // window.addEventListener('drag', this.changeShadowPosition)
        // window.addEventListener('dragend', this.onDrop)

        // let shadowElement = []
        // console.log(this[id].row)
        // shadowElement = shadowElement.push(Object(this[id].row))
        // console.log(this[id].props.children)
        // let shadowElement = React.cloneElement(this[id].row,{})
        // console.log(shadowElement)
        // this.setState({ shadowElement })
    }

    changeShadowPosition = (e) => {
        // console.log(e)
        if (this.shadowChild) {
            this.shadowChild.style.top = (e.clientY - 10) + 'px'
            this.shadowChild.style.left = e.clientX + 2 + 'px'

        }
        //    console.log(this.shadowChild.style)
        // this.setState({ shadowLeft: e.clientX ? e.clientX + 2 : null, shadowTop: e.clientY - 10 })
    }

    dragOver = (id) => {
        // console.log("HERE", this.props.id, id)
        if (!this.props.disableDragOver) {
            let dragId = this.state.dragId ?? this.props.dragId
            // this.dragOverId = id
            // console.log("dragId", dragId, id)


            if (dragId !== id && this.dragOverId != id) {
                // if (dragId !== id) {

                this.dragOverId = id

                // console.log("HERE1", this.props.dragSource, this.props.id)

                if (this.props.dragSource != this.props.id && this.props.updateParent) {
                    // this.checkParentLoop(dragId,)
                    this.props.updateParent(dragId, this.props.id, () => {
                        if (this.props.setDragInfo) {
                            this.props.setDragInfo(this.props.dragId, this.props.id)
                        }
                        this.animateSorting(dragId, id)
                    })

                } else {
                    this.animateSorting(dragId, id)

                }

            }
        }
    }



    animateSorting = (dragId, overId) => {
        let dragIndex = null
        let overIndex = null
        // console.log("AMINATE")
        this.props.data.forEach((element, index) => {
            // console.log(element.id)
            let id = element.id ?? element._id
            if (id === dragId) {
                dragIndex = index
            }
            if (id === overId) {
                overIndex = index
            }
        });

        // console.log(dragId)
        // console.log(overId)
        // console.log(dragIndex, overIndex)

        if (dragIndex !== null && overIndex !== null) {

            this.bounds = this.getElementsBounds(this.props.data)

            // console.log(this.bounds)

            let data = this.props.data
            let temp = data[dragIndex]
            data.splice(dragIndex, 1)
            data.splice(overIndex, 0, temp)

            this.props.updatedata(data, () => {
                let newBounds = this.getElementsBounds(this.props.data)

                requestAnimationFrame(() => {

                    this.setState({ isAnimating: true }, () => {
                        Object.keys(this.bounds).forEach(key => {

                            const deltaX = this.bounds[key].left - newBounds[key].left;
                            const deltaY = this.bounds[key].top - newBounds[key].top;

                            if (deltaX !== 0 || deltaY !== 0) {

                                let domNode = this[key]?.draggableItem
                                if (domNode) {
                                    domNode.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
                                    domNode.style.transition = 'transform 0s';
                                    requestAnimationFrame(() => {
                                        // this.dragOverId = null
                                        // In order to get the animation to play, we'll need to wait for
                                        // the 'invert' animation frame to finish, so that its inverted
                                        // position has propagated to the DOM.
                                        //
                                        // Then, we just remove the transform, reverting it to its natural
                                        // state, and apply a transition so it does so smoothly.
                                        domNode.style.transform = '';
                                        domNode.style.transition = 'transform 300ms';

                                    });
                                }
                            }
                        });
                    })
                    let dragOverId = this.dragOverId
                    setTimeout(() => {
                        if (dragOverId === this.dragOverId) {
                            this.dragOverId = null
                        }
                        this.setState({ isAnimating: false })

                    }, 350);
                })
            })

        }
    }

    getElementsBounds(data) {
        let bounds = {}
        data.forEach(element => {
            let id = element.id ?? element._id

            if (this[id]) {
                // console.log(this[id])
                bounds[id] = getBoundingClientRect(this[id].draggableItem)
            }
        });
        return bounds
    }

    onDrop = (id) => {

        // console.log("onDrop")
        this.setState({ dragId: null })
        if (this.props.setDragInfo) {
            this.props.setDragInfo(null, null)
        }
        // this.setState({ dragId: null })
        // this.dragOverId = null
        // console.log("DROP")
        // window.removeEventListener('drag', this.changeShadowPosition)
        // window.removeEventListener('mouseup', this.onDrop)

    }

    onDrag = (e) => {
        // console.log(e.clientX)
        // console.log(e.clientY )
        // this.setState({ shadowLeft: e.clientX+2, shadowTop: e.clientY })

        this.changeShadowPosition(e)
    }

    dragEnd = (e) => {
        this.setState({ dragId: null })
        this.dragOverId = null

        if (this.props.setDragInfo) {
            this.props.setDragInfo(null, null)
        }
        // console.log("DRAG END")
    }

    onDragEnter = (e) => {

        e.preventDefault()

        if (!this.state.isAnimating && !this.props.disableDragOver && this.props.children?.length == 0) {

            e.stopPropagation()
            this.setState({ isOver: true })
        }
    }

    onDragLeave = (e) => {

        this.setState({ isOver: false })
    }

    onDropToList = (e) => {

        e.stopPropagation()
        if (this.props.children?.length == 0) {
            let source, draggableId, sourceIndex

            if (e.dataTransfer.getData) {
                draggableId = e.dataTransfer.getData("id");
                sourceIndex = e.dataTransfer.getData("index");
                source = e.dataTransfer.getData("source");

            } else {
                draggableId = e.dataTransfer.id;
                sourceIndex = e.dataTransfer.index;
                source = e.dataTransfer.source;
            }

            this.setState({ isOver: false })
            this.props.onDragEndAction({ source: { droppableId: source, index: sourceIndex }, destination: { droppableId: this.props.id, index: 0 }, draggableId })

        }
        this.setState({ dragId: null })
        if (this.props.setDragInfo) {
            this.props.setDragInfo(null, null)
        }
    }


    render() {
        let shadowChild
        if (this.props.children) {
            var children = []
            if (Array.isArray(this.props.children)) {
                children = this.props.children.map(function (child, i) {
                    if (child.key === (this.props.dragId ?? this.state.dragId)) {
                        shadowChild = React.cloneElement(child)
                    }
                    return (
                        <Draggable ref={el => this[child.key] = el} id={child.key ?? child._key} index={i} key={'draggable' + child.key} onDrag={this.onDrag} dragStarted={this.dragStarted} dragOver={this.dragOver} onDrop={this.onDrop} dragEnd={this.dragEnd}>
                            {React.cloneElement(child,
                                { key: child.key }
                            )}

                            {(child.key === (this.props.dragId ?? this.state.dragId)) && (
                                <div className="drop-ghost" style={{ zIndex: 2, position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', backgroundColor: 'rgba(230,240,245,0.9)', border: '1px dotted #007aff40' }}></div>
                            )}
                        </Draggable>
                    )

                }, this);
            } else {
                children = React.cloneElement(this.props.children, {})

            }
            // console.log(shadowChild)
            return (
                <div ref={el => this.draggableList = el} className={"w-100 br-4 draggableList " + (this.state.dragId ? "isDragging" : '')} onDragEnter={e => this.onDragEnter(e)} style={{ minHeight: 10, background: this.state.isOver ? '#007aff20' : null, border: this.state.isOver ? '1px dotted #007aff' : '1px dotted transparent' }} onDragLeave={(e) => this.onDragLeave(e)} onDrop={(e) => this.onDropToList(e)} onDragOver={(e) => e.preventDefault()}>

                    {children}

                    {/* {shadowChild && (
                        <div className=" blur-back" ref={el => this.shadowChild = el} style={{ width: this.props.width, overflow: 'hidden', backgroundColor: '#ffffffcc', boxShadow: '0px 0px 15px #00000010', zIndex: 6, position: 'fixed', transform: 'rotate(0.5deg)' }}>
                            {shadowChild}
                        </div>
                    )} */}

                </div>
            )
        }
        else {
            return <div></div>
        }
    }

}

export default DraggableList
